import React from "react";
import { arrayOf, bool, shape, string } from "prop-types";

import {
  Column,
  Container,
  Dropdown,
  List,
  ListItem,
  ListItemLink,
  Title
} from "../MainNav/Dropdown";
import { useMainNavDropdown } from "../MainNav/hooks";
import LinksList from "../MainNav/LinksList";
import { DEFAULT_DROPDOWN_TITLE } from "./constants";
import * as S from "./styled";

const IndustryHubMainNavDropdown = ({
  has_comparables,
  has_openhouses,
  is_full_width,
  is_wide,
  popular_agent_resources,
  title
}) => {
  const {
    dropdownRef,
    isActive,
    onClick,
    onMouseEnter,
    onMouseLeave
  } = useMainNavDropdown({
    event_label: "Resourses",
    event_value: ""
  });
  const resourcesDataGtm = {
    "data-gtm-header-menu": "Resources"
  };
  return (
    <>
      <S.IndustryHubDropdownButton
        ref={dropdownRef}
        aria-expanded={isActive}
        aria-haspopup="true"
        aria-label={DEFAULT_DROPDOWN_TITLE}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        title={title}
      >
        <Dropdown isActive={isActive} role="tooltip">
          <Container isFullWidth={!!is_full_width} isWide={!!is_wide}>
            <Column>
              <Title>Categories</Title>
              <List hasBottomPadding>
                <ListItem>
                  <ListItemLink
                    href="/blog/industry-hub/real-estate-tips/"
                    {...resourcesDataGtm}
                  >
                    Real Estate Tips
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/blog/industry-hub/building-your-brand/"
                    {...resourcesDataGtm}
                  >
                    Building Your Brand
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/blog/industry-hub/industry-events/"
                    {...resourcesDataGtm}
                  >
                    Industry Events
                  </ListItemLink>
                </ListItem>
              </List>
              <Title>Tools</Title>
              <List>
                <ListItem>
                  <ListItemLink
                    href="/blog/market-reports/"
                    {...resourcesDataGtm}
                  >
                    Market Report
                  </ListItemLink>
                </ListItem>
                {has_comparables ? (
                  <ListItem>
                    <ListItemLink href="/my/comparables" {...resourcesDataGtm}>
                      Comparables Reports
                    </ListItemLink>
                  </ListItem>
                ) : null}
                {has_openhouses ? (
                  <ListItem>
                    <ListItemLink
                      href="/nyc/open_house_planner"
                      {...resourcesDataGtm}
                    >
                      Open House Planner
                    </ListItemLink>
                  </ListItem>
                ) : null}
                <ListItem>
                  <ListItemLink
                    href="https://streeteasy.com/blog/data-dashboard/"
                    {...resourcesDataGtm}
                  >
                    Data Dashboard
                  </ListItemLink>
                </ListItem>
              </List>
            </Column>
            <Column isAgentResources>
              <LinksList
                linkProps={resourcesDataGtm}
                linksList={popular_agent_resources}
                title="Most popular"
              />
            </Column>
          </Container>
        </Dropdown>
      </S.IndustryHubDropdownButton>
    </>
  );
};

IndustryHubMainNavDropdown.propTypes = {
  is_wide: bool,
  is_full_width: bool,
  has_comparables: bool,
  has_openhouses: bool,
  popular_agent_resources: arrayOf(
    shape({
      title: string,
      link: string
    })
  ),
  title: string
};

IndustryHubMainNavDropdown.defaultProps = {
  is_wide: false,
  is_full_width: false,
  has_comparables: false,
  has_openhouses: false,
  popular_agent_resources: [],
  title: DEFAULT_DROPDOWN_TITLE
};

export default IndustryHubMainNavDropdown;
